module.exports = __webpack_public_path__ + "media/video.b3e0045a.mp4";